import { BusinessState } from "@/modules/businesses/types";

export const ProcessingUser = {
  disabled: false,
  email: "",
  firstName: "",
  id: "",
  lastName: "",
  role: 0,
};

export const BaseBusiness = {
  id: "",
  name: "",
  registrationNumber: 0,
  country: "",
  documents: [],
  createdAt: "",
  owners: [],
  processedByUser: { ...ProcessingUser },
};

const state: BusinessState = {
  sortOrder: "desc",
  sortBy: "creationDate",
  currentBusinessOwners: {
    pageIndex: 1,
    totalPages: 1,
    totalItems: 2,
    items: [],
    hasPreviousPage: false,
    hasNextPage: false,
  },
  selectedBusiness: { ...BaseBusiness },
  businesses: {
    pageIndex: 1,
    totalPages: 1,
    totalItems: 2,
    items: [],
    hasPreviousPage: false,
    hasNextPage: false,
  },
  currentBusiness: { ...BaseBusiness },
  isViewing: "all",
  allApprovedBusinesses: {
    pageIndex: 1,
    totalPages: 0,
    totalItems: 0,
    items: [],
    hasPreviousPage: false,
    hasNextPage: false,
  },
  allRejectedBusinesses: {
    pageIndex: 1,
    totalPages: 0,
    totalItems: 0,
    items: [],
    hasPreviousPage: false,
    hasNextPage: false,
  },
  allPendingBusinesses: {
    pageIndex: 1,
    totalPages: 0,
    totalItems: 0,
    items: [],
    hasPreviousPage: false,
    hasNextPage: false,
  },
  isFetchingBusinesses: false,
  isFetchingBusinessOwners: false,
  query: "",
};

export default state;
